class ThemingConfiguration {
    public static $inject = ["$mdThemingProvider"];

    constructor($mdThemingProvider) {
        $mdThemingProvider.definePalette("thorBackground", $mdThemingProvider
            .extendPalette("grey", {
                "50": "#FBFAF8"
            })
        );

        $mdThemingProvider.definePalette("thorAccent", {
            "50": "#fceeea",
            "100": "#f6d4c9",
            "200": "#f1b8a6",
            "300": "#eb9b82",
            "400": "#e68567",
            "500": "#e2704c",
            "600": "#df6845",
            "700": "#da5d3c",
            "800": "#d65333",
            "900": "#cf4124",
            "A100": "#f1b8a6",
            "A200": "#e2704c",
            "A400": "#da5d3c",
            "A700": "#cf4124",
            "contrastDefaultColor": "light",
            "contrastDarkColors": ["50", "100", "200", "300", "400"],
            "contrastLightColors": ["A100", "A200", "A400", "A700", "500", "600", "700", "800", "900"]
        });

        $mdThemingProvider.definePalette("thorPrimary", {
            "50": "#e7e9ec",
            "100": "#c2c8cf",
            "200": "#9aa4af",
            "300": "#71808e",
            "400": "#526476",
            "500": "#34495e",
            "600": "#2f4256",
            "700": "#27394c",
            "800": "#213142",
            "900": "#152131",
            "A100": "#72adff",
            "A200": "#3f8fff",
            "A400": "#0c71ff",
            "A700": "#0065f1",
            "contrastDefaultColor": "light",
            "contrastDarkColors": ["50", "100", "200", "A100", "A200"],
            "contrastLightColors": ["300", "400", "500", "600", "700", "800", "900", "A400", "A700"]
        });

        $mdThemingProvider.definePalette("lokiPrimary", {
            "50":   "#C7DBE5",
            "100":  "#93B9CC",
            "200":  "#6DA0BB",
            "300":  "#487D99",
            "400":  "#3E6C84",
            "500":  "#345B6F",
            "600":  "#2A4A5A",
            "700":  "#203945",
            "800":  "#172830",
            "900":  "#0D171C",
            "A100": "#C7DBE5",
            "A200": "#93B9CC",
            "A400": "#3E6C84",
            "A700": "#203945",
            "contrastDefaultColor": "light",
            "contrastDarkColors": ["50", "100", "200", "A100", "A200"]
        });

        $mdThemingProvider.definePalette("lokiAccent", {
            "50":   "#D1F0FF",
            "100":  "#85D6FF",
            "200":  "#4DC4FF",
            "300":  "#05ACFF",
            "400":  "#0099E6",
            "500":  "#0085C7",
            "600":  "#0071A8",
            "700":  "#005C8A",
            "800":  "#00486B",
            "900":  "#00334D",
            "A100": "#D1F0FF",
            "A200": "#85D6FF",
            "A400": "#0099E6",
            "A700": "#005C8A",
            "contrastDefaultColor": "light",
            "contrastDarkColors": ["50", "100", "200", "300", "A100", "A200"]
        });

        $mdThemingProvider.theme("default")
            .primaryPalette("thorPrimary")
            .accentPalette("thorAccent")
            .warnPalette("red")
            .backgroundPalette("thorBackground", {
                "default": "50"
            });

        $mdThemingProvider.theme("dark")
            .primaryPalette("thorPrimary")
            .accentPalette("thorAccent")
            .warnPalette("red")
            .dark();

        $mdThemingProvider.theme("loki")
            .primaryPalette("lokiPrimary")
            .accentPalette("lokiAccent", {
                "default": "500"
            })
            .warnPalette("red", {
                "default": "A700"
            });

        $mdThemingProvider.enableBrowserColor();
    }
}

angular
    .module("thor.theming", [])
    .config(ThemingConfiguration);
